// 用按环境注入的 SUPP_H5_URL(vite.config.{prod|pre|uat|dev}.js 各自定义),
// prod=https://front.suppart.app; 原来硬编码 front.suppart.dev 导致生产通知深链指向 dev 域名(2026-07-02 修)
const BASE_URL = SUPP_H5_URL;

export enum UniversalLinkPage {
  tagDetail = 'tagDetail', // 标签详情
  artworkDetail = 'artworkDetail', // 作品详情
  profile = 'profile', // 用户主页
  webview = 'webview', // 网页
  browser = 'browser', // 浏览器
  contestDetail = 'contestDetail', // 新增 contest 页面类型
  rookieKingDetail = 'rookieKingDetail', // 新人王链接跳转
}

/**
 * 创建标签详情链接
 *
 * @param name 标签名称
 * @returns 标签详情链接
 */
export const createTagDetailLink = (name: string) => {
  return `${BASE_URL}?page=${UniversalLinkPage.tagDetail}&tagName=${name}`;
};

/**
 * 创建作品详情链接
 *
 * @param id 作品id
 * @returns 作品详情链接
 */
export const createArtworkDetailLink = (id: string) => {
  return `${BASE_URL}?page=${UniversalLinkPage.artworkDetail}&artworkId=${id}`;
};

/**
 * 创建网页链接
 *
 * @param url 网页链接
 * @returns 网页链接
 */
export const createWebviewLink = (url: string) => {
  const encodedUrl = encodeURIComponent(url);
  return `${BASE_URL}?page=${UniversalLinkPage.webview}&url=${encodedUrl}`;
};

export const createBrowserLink = (url: string) => {
  return `${BASE_URL}?page=${UniversalLinkPage.browser}&url=${url}`;
};

/**
 * 创建比赛详情链接
 *
 * @param id 比赛 ID
 * @returns 比赛详情链接
 */
export const createContestDetailLink = (id: string) => {
  return `${BASE_URL}?page=${UniversalLinkPage.contestDetail}&contestId=${id}`;
};

/**
 * 创建新人王链接
 *
 * @param id 新人王 ID
 * @returns 新人王链接
 */
export const createNewcomerContestLink = (id: string) => {
  return `${BASE_URL}?page=${UniversalLinkPage.rookieKingDetail}&rookieKingId=${id}`;
};

/**
 * 从链接中获取值
 *
 * @param link 链接
 * @param type 链接类型
 * @returns 值
 */
export const getValueFromLink = (link: string, type: UniversalLinkPage) => {
  try {
    // 判断是否已包含协议头
    const fullLink = new URL(
      link.startsWith('http://') || link.startsWith('https://')
        ? link
        : `https://${link}`
    );
    if (type === UniversalLinkPage.webview) {
      return fullLink.searchParams.get('url') || fullLink.toString();
    }
    if (type === UniversalLinkPage.browser) {
      return fullLink.searchParams.get('url') || fullLink.toString();
    }
    if (type === UniversalLinkPage.tagDetail) {
      return fullLink.searchParams.get('tagName');
    }
    if (type === UniversalLinkPage.artworkDetail) {
      return fullLink.searchParams.get('artworkId');
    }
    if (type === UniversalLinkPage.contestDetail) {
      return fullLink.searchParams.get('contestId');
    }
    if (type === UniversalLinkPage.rookieKingDetail) {
      return fullLink.searchParams.get('rookieKingId');
    }
    return '';
  } catch (e) {
    return '';
  }
};
